"use strict";
export var TokenList = /* @__PURE__ */ ((TokenList2) => {
  TokenList2["Default"] = "default";
  TokenList2["NonDefault"] = "non_default";
  TokenList2["Blocked"] = "blocked";
  return TokenList2;
})(TokenList || {});
export var AttackType = /* @__PURE__ */ ((AttackType2) => {
  AttackType2["Honeypot"] = "honeypot";
  AttackType2["Airdrop"] = "airdrop";
  AttackType2["Impersonator"] = "impersonator";
  AttackType2["HighFees"] = "high-fees";
  AttackType2["Other"] = "other";
  return AttackType2;
})(AttackType || {});
